import React from 'react';
import { Box, Typography, useTheme, useMediaQuery, CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import moment from 'moment';
import { getWeekdaysWithDates } from '../utils';

const WeekdayDateSelector = ({
  selectedDay = 3,
  onDateSelect,
  weeklyStats = [],
  customDates = null,
  showArrow = false,
  arrowPosition = null,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const dates = customDates || getWeekdaysWithDates();

  const getProgressForDay = (day) => {
    const dayStats = weeklyStats.find((stat) => stat.date === day.format('YYYY-MM-DD'));

    if (!dayStats) return 0;

    // If there are scheduled medications, calculate progress based on adherence rate
    if (dayStats.scheduled > 0) {
      return dayStats.adherenceRate || 0;
    }

    // If no scheduled medications, return 0
    return 0;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        overflowX: isMobile ? 'auto' : 'visible',
        gap: 1,
      }}
    >
      {dates.map((day, index) => {
        const progress = getProgressForDay(day);

        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: index === selectedDay ? '#01796b' : '#EBEBEB',
              borderRadius: '20px',
              p: 0.5,
              pt: 1,
              pb: 1,
              minWidth: isMobile ? '40px' : 'auto',
              color: index === selectedDay ? '#fff' : 'black',
              cursor: 'pointer',
              position: 'relative',
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: index === selectedDay ? '#01796b' : '#f5f5f5',
              },
            }}
            onClick={() => onDateSelect && onDateSelect(index, day)}
          >
            {/* {showArrow && arrowPosition === index && (
              <Box
                sx={{
                  position: 'absolute',
                  top: -8,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 0,
                  height: 0,
                  borderLeft: '6px solid transparent',
                  borderRight: '6px solid transparent',
                  borderBottom: '8px solid black',
                }}
              />
            )} */}
            <Typography variant="body2">{day.format('ddd')}</Typography>
            <Typography variant="body2">{day.format('DD')}</Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 30,
                height: 30,
                bgcolor: progress === 100 && index === selectedDay ? 'white' : progress === 100 ? '#01796b' : 'white',
                borderRadius: '50%',
              }}
            >
              {progress === 100 ? (
                <CheckIcon
                  sx={{
                    color: progress === 100 && index === selectedDay ? '#01796b' : 'white',
                    fontSize: 16,
                  }}
                />
              ) : (
                <CircularProgress
                  variant="determinate"
                  value={progress}
                  sx={{
                    width: '28px !important',
                    height: '28px !important',
                    color: '#01796b',
                    '& .MuiCircularProgress-circle': {
                      strokeWidth: 4,
                      stroke: '#01796b',
                    },
                  }}
                />
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default WeekdayDateSelector;
